import { ReactComponent as FlexibookLogo } from "../../../assets/flexibook-logo.svg";
import { ReactComponent as AnyspotLogo } from "../../../assets/anyspot-logo.svg";
import { BRAND, getBrand } from "../../../utility/branding";

const BrandLogo = (props) =>
  getBrand() === BRAND.ANYSPOT ? <AnyspotLogo {...props} /> : <FlexibookLogo {...props} />;

export default BrandLogo;
